import { useEffect, useState } from 'react'

// Entrance animations for the admin numbers and charts. Everything snaps to its
// final state when the visitor has asked for reduced motion.

function reducedMotion() {
  return typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

export const easeOutCubic = (t: number) => 1 - (1 - t) ** 3
export const easeInOutCubic = (t: number) => (t < 0.5 ? 4 * t ** 3 : 1 - (-2 * t + 2) ** 3 / 2)

/** Eased 0 → 1 over `duration` ms, restarting whenever `restartKey` changes. */
export function useProgress(duration: number, ease = easeOutCubic, restartKey: unknown = null) {
  const [progress, setProgress] = useState(() => (reducedMotion() ? 1 : 0))

  useEffect(() => {
    if (reducedMotion()) return
    let frame = 0
    let start: number | null = null
    const tick = (now: number) => {
      start ??= now
      const t = Math.min(1, (now - start) / duration)
      setProgress(ease(t))
      if (t < 1) frame = requestAnimationFrame(tick)
    }
    frame = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(frame)
  }, [duration, ease, restartKey])

  return progress
}
